// Participant utilities

export const getParticipantStatusIcon = (status: string) => {
  switch (status) {
    case 'Confirmed':
    case 'ConfirmedBySystem':
      return '✅';
    case 'Pending':
      return '⏳';
    case 'Cancelled':
      return '❌';
    case 'Replaced':
      return '🔄';
    case 'Deleted':
      return '🗑️';
    default:
      return '❓';
  }
};

export const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const getAvatarColor = (name: string): string => {
  const colors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-purple-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-red-500',
    'bg-yellow-500',
    'bg-teal-500',
    'bg-orange-500',
    'bg-cyan-500',
  ];

  const index =
    name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) %
    colors.length;
  return colors[index];
};
